var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showsSearch,
      expression: "showsSearch"
    }]
  }, [_c('v-card', _vm._b({
    staticClass: "mb-3",
    attrs: {
      "flat": "",
      "outlined": ""
    }
  }, 'v-card', Object.assign({}, _vm.$attrs, {
    loading: _vm.loading
  }), false), [_vm.dense ? [!_vm.hideLabel ? _c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")]) : _vm._e(), _c('v-card-text', [_c('v-row', {
    staticClass: "ma-n3",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_vm._t("default")], 2), !_vm.hideActions ? _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('search');
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-magnify")]), _vm._v(" 검색 ")], 1)], 1) : _vm._e()], 1)], 1)] : [!_vm.hideLabel ? _c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")]) : _vm._e(), _c('v-card-text', {
    staticClass: "py-0"
  }, [_vm._t("default")], 2), !_vm.hideActions ? _c('v-card-actions', [_c('v-spacer'), _c('v-btn', _vm._b({
    attrs: {
      "color": "primary",
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('search');
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-magnify")]), _vm._v(" 검색 ")], 1)], 1) : _vm._e()]], 2)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }